/**
 * Collection page URL param effects.
 * Query params from the page URL are read on DOMContentLoaded and applied via handlers below.
 *
 * Adding a new URL param:
 * 1. Add a key to URL_PARAM_HANDLERS matching the param name (e.g. ?pagetitle=Hello).
 * 2. Handler receives (value) — the param value as a string, or null if missing.
 *
 * For simple text updates: use updateTextElements(selector, value). Put data-url-param="paramname"
 * on the target elements, or pass any CSS selector.
 * For custom behavior: write a (value) => { ... } function that does its own DOM/UX logic.
 */
if (!window.urlParamEffectsInitialized) {
    window.urlParamEffectsInitialized = true;

    function updateTextElements(selector, value) {
        document.querySelectorAll(selector).forEach((el) => (el.textContent = value));
    }

    const URL_PARAM_HANDLERS = {
        pagetitle: (value) => updateTextElements('[data-url-param="pagetitle"]', value),
        plpheadline: (value) => updateTextElements('[data-url-param="pagetitle"]', value),
        otp: (value) => {
            if (value === 'true') {
                document.querySelectorAll('[data-plp-add-to-cart-form] input[data-selling-plan-input]').forEach(input => input.remove());
            }
        }
    };

    function applyUrlParamEffects() {
        const urlParams = new URLSearchParams(window.location.search);
        Object.entries(URL_PARAM_HANDLERS).forEach(([param, handler]) => {
            const value = urlParams.get(param);
            if (value !== null) handler(value);
        });
    }

    document.addEventListener('DOMContentLoaded', applyUrlParamEffects);
}